<template>
  <v-card class="timestamp-converter tools-view-card">
    <ToolbarHeader :name="'Timestamp Converter'"/>
    <v-container>
      <section class="ma-5">
        <v-row>
          <v-col cols="12"
                 sm="12"
                 md="6">
            <v-form v-on:submit.prevent="dateAndTimeFormSubmit"
                    v-model="dateAndTimeFormOptions.valid">
              <p>Enter a Date & Time:</p>
              <v-row>
                <v-col>
                  <v-text-field
                      required
                      :rules="dateAndTimeFormOptions.year"
                      @input="result = false"
                      name="Year"
                      v-model="dateAndTimeForm.year"
                      type="number"
                      label="Year"
                      prepend-icon="mdi-calendar"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                      required
                      :rules="dateAndTimeFormOptions.month"
                      name="Month"
                      @input="result = false"
                      label="Month"
                      v-model="dateAndTimeForm.month"
                      type="number"/>
                </v-col>
                <v-col>
                  <v-text-field
                      required
                      :rules="dateAndTimeFormOptions.day"
                      name="Day"
                      type="number"
                      @input="result = false"
                      v-model="dateAndTimeForm.day"
                      label="Day"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                      required
                      :rules="dateAndTimeFormOptions.hour"
                      name="Hour"
                      @input="result = false"
                      v-model="dateAndTimeForm.hour"
                      type="number"
                      label="Hour"
                      prepend-icon="mdi-clock-outline"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                      required
                      name="Minute"
                      @input="result = false"
                      v-model="dateAndTimeForm.minute"
                      :rules="dateAndTimeFormOptions.minute"
                      type="number"
                      label="Minute"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                      required
                      name="Second"
                      @input="result = false"
                      v-model="dateAndTimeForm.second"
                      :rules="dateAndTimeFormOptions.second"
                      type="number"
                      label="Second"
                  />
                </v-col>
              </v-row>
              <v-btn
                  :disabled="!dateAndTimeFormOptions.valid"
                  color="primary"
                  class="mt-1 w-100"
                  type="submit"
              >
                Convert to timestamp
              </v-btn>
            </v-form>

            <v-form v-on:submit.prevent="timestampFormSubmit"
                    v-model="timestampFormOptions.valid"
                    class="mt-5"
            >
              <p>Enter Timestamp:</p>
              <v-text-field
                  required
                  @input="result = false"
                  :rules="timestampFormOptions.timestamp"
                  name="Timestamp"
                  type="number"
                  v-model="timestampForm.timestamp"
                  label="Timestamp"
                  prepend-icon="mdi-numeric"
              />

              <v-btn
                  type="submit"
                  :disabled="!timestampFormOptions.valid"
                  color="primary"
                  class="mt-1 w-100"
              >
                Convert to date & time
              </v-btn>
            </v-form>
          </v-col>
        </v-row>

      </section>
    </v-container>
  </v-card>
</template>

<script>
import ToolbarHeader from "@/components/Toolbar-Header";

const dateAndTimeForm = {
  year: null,
  month: null,
  day: null,
  hour: null,
  minute: null,
  second: null,
};

const timestampForm = {
  timestamp: null
};

export default {
  name: "Timestamp-Converter",
  components: {ToolbarHeader},
  data: () => ({
    dateAndTimeForm: Object.assign({}, dateAndTimeForm),
    dateAndTimeFormOptions: {
      valid: false,
      year: [
        v => !!v || 'Year is required',
      ],
      month: [
        v => !!v || 'Month is required',
        v => v <= 12 || 'Invalid month',
        v => v > 0 || 'Invalid month',
      ],
      day: [
        v => !!v || 'Day is required',
        v => v <= 31 || 'Invalid day',
        v => v > 0 || 'Invalid day',
      ],
      hour: [
        v => v <= 24 || 'Invalid hour',
        v => v >= 0 || 'Invalid hour',
      ],
      minute: [
        v => v <= 60 || 'Invalid minute',
        v => v >= 0 || 'Invalid minute',
      ],
      second: [
        v => v <= 60 || 'Invalid hour',
        v => v >= 0 || 'Invalid hour',
      ],
    },
    timestampForm: Object.assign({}, timestampForm),
    timestampFormOptions: {
      valid: false,
      timestamp: [
        v => !!v || 'Timestamp is required',
      ],
    }
  }),
  mounted() {
    this.setTimestamp(new Date());
    this.setDateAndTime(this.timestampForm.timestamp);
  },
  methods: {
    dateAndTimeFormSubmit() {
      const dateAndTime = `${this.dateAndTimeForm.month}/${this.dateAndTimeForm.day}/${this.dateAndTimeForm.year} ${this.dateAndTimeForm.hour}:${this.dateAndTimeForm.minute}:${this.dateAndTimeForm.second}`;
      try {
        this.setTimestamp(dateAndTime);
      } catch (e) {
        throw new Error(e);
      }
    },
    timestampFormSubmit() {
      try {
        this.setDateAndTime(parseInt(this.timestampForm.timestamp));
      } catch (e) {
        throw new Error(e);
      }
    },
    setTimestamp(dateAndTime) {
      this.timestampForm.timestamp = new Date(dateAndTime).getTime();
    },
    setDateAndTime(timestamp) {
      while (timestamp > 9111111111000) {
        timestamp = timestamp / 1000;
      }

      const date = new Date(timestamp);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let dt = date.getDate();
      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }

      const hours = date.getHours();
      const minutes = "0" + date.getMinutes();
      const seconds = "0" + date.getSeconds();
      this.dateAndTimeForm = {
        year: parseInt(year),
        month: parseInt(month),
        day: parseInt(dt),
        hour: parseInt(hours),
        minute: parseInt(minutes.substr(-2)),
        second: parseInt(seconds.substr(-2))
      }
    },
  }
}
</script>

<style scoped>

</style>
